import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const MultiTouch = lazy(() => import('../MultiTouch'));

const multiTouchRoute: RouteObject = {
  path: '/multi-touch',
  element: <MultiTouch />,
};

export default multiTouchRoute;
